/* Huevo de pascua — Vendotractos.
 *
 * Sustituye el "Tecnologia de Shopify" del pie por un camioncito casi
 * transparente. Quien lo note y le de clic se va al video del Tiger 6G.
 *
 * Hay una segunda puerta, mas escondida: teclear "6g" en cualquier pagina.
 * El buffer se limpia solo a los dos segundos, asi que no se dispara por
 * accidente mientras alguien escribe en el buscador.
 *
 * El enlace del pie es un <a> de verdad, no un window.open: asi el clic nunca
 * lo bloquea el navegador y funciona con clic de rueda o "abrir en pestaña".
 */
(function () {
  'use strict';

  var VIDEO = 'https://www.youtube.com/watch?v=ULLEHXFA81E';
  var CLAVE = '6g';

  var CAMION =
    '<svg viewBox="0 0 40 24" width="26" height="16" fill="currentColor" aria-hidden="true">' +
    '<path d="M2 6h18v10H2z"/><path d="M22 9h7l5 5v2h-12z"/>' +
    '<circle cx="10" cy="18" r="3.2"/><circle cx="28" cy="18" r="3.2"/>' +
    '</svg>';

  function ponerEnElPie() {
    var pie = document.querySelector('.footer__copyright');
    if (!pie || pie.querySelector('[data-vt-huevo]')) return;

    // El enlace de Shopify se oculta por CSS; aqui se reusa su hueco.
    var hueco = pie.querySelector('a[href*="shopify.com"]');
    var caja = hueco ? hueco.parentElement : pie;

    var liga = document.createElement('a');
    liga.href = VIDEO;
    liga.target = '_blank';
    liga.rel = 'noopener';
    liga.className = 'vt-huevo';
    liga.setAttribute('data-vt-huevo', '');
    liga.setAttribute('aria-label', 'Sorpresa Vendotractos');
    liga.innerHTML = CAMION;

    if (hueco) hueco.remove();
    caja.appendChild(liga);
  }

  function escucharLaClave() {
    var buffer = '';
    var reloj = null;

    document.addEventListener('keydown', function (evento) {
      if (evento.metaKey || evento.ctrlKey || evento.altKey) return;
      if (evento.key.length !== 1) return;

      // Si esta escribiendo en un campo no cuenta: alguien buscando "6G" en el
      // buscador del sitio no merece que le abra una pestaña de YouTube.
      var donde = evento.target;
      if (
        donde &&
        (donde.isContentEditable ||
          donde.tagName === 'INPUT' ||
          donde.tagName === 'TEXTAREA' ||
          donde.tagName === 'SELECT')
      ) {
        return;
      }

      buffer = (buffer + evento.key).toLowerCase().slice(-CLAVE.length);

      clearTimeout(reloj);
      reloj = setTimeout(function () {
        buffer = '';
      }, 2000);

      if (buffer === CLAVE) {
        buffer = '';
        // Va dentro del keydown, asi que cuenta como gesto del usuario.
        window.open(VIDEO, '_blank', 'noopener');
      }
    });
  }

  function arrancar() {
    ponerEnElPie();
    escucharLaClave();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }
})();
